var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{staticClass:"title-size-cleed",attrs:{"title":_vm.title,"level":2}}),_c('Title',{staticClass:"title-size-cleed",style:(_vm.colorBrandProduct),attrs:{"title":_vm.brandProduct,"level":_vm.brandProductSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }